/** Small helper: red asterisk suffix for a required-field label. */
export const Req = () => <span className="text-rose-500 ml-0.5" aria-hidden="true">*</span>;

export const CATEGORIES = ["Physical", "Vital", "Vision & Hearing", "Dental", "Nutrition", "Life style", "Emotion", "Medical History"];
